import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import type {ICreateFinancialApplicationRequest} from "../types/financial_application";

const financialApplicationEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        createFinancialApplication: builder.mutation<unknown, ICreateFinancialApplicationRequest>({
            query: (body) => ({
                url: apiPath.applications.financialApplication.create,
                method: "POST",
                body
            })
        })
    })
});

export const {useCreateFinancialApplicationMutation} = financialApplicationEndpoints;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import type {ICreateFinancialApplicationRequest} from "../types/financial_application";

const financialApplicationEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        createFinancialApplication: builder.mutation<unknown, ICreateFinancialApplicationRequest>({
            query: (body) => ({
                url: apiPath.applications.financialApplication.create,
                method: "POST",
                body
            })
        })
    })
});

export const {useCreateFinancialApplicationMutation} = financialApplicationEndpoints;
